import type { Course, Enum_Like_Type, Resource } from '@edwin-group/cj-graphql/generated/graphql';

import BookmarkButton from '../Bookmark/BookmarkButton';
import LikeButton from '../LikeButton';
import { GENERATED } from '@edwin-group/cj-graphql';
import { ChapterBookmark } from '@/types/types';

type TitleWithActionsProps = {
  title: string;
  entity: Resource | Course | ChapterBookmark;
  entityId: string;
  moduleId?: string;
  lessonId?: string;
  like?: boolean;
  favorite?: boolean;
  type?: Enum_Like_Type;
  category?: GENERATED.Enum_Bookmark_Category;
  textSize?: string;
  resourceTypeId?: string;
};

export default function TitleWithActions({
  title,
  like = true,
  favorite = true,
  entity,
  entityId,
  lessonId,
  moduleId,
  category,
  textSize = 'text-sh-36-48',
  type,
  resourceTypeId,
}: TitleWithActionsProps) {
  return (
    <div className="flex items-start justify-between gap-2">
      <h1 className={`font-cadiz ${textSize} font-bold`}>{title}</h1>
      <div className="mt-sh-15 flex gap-sh-15">
        <div className="flex items-center justify-center">
          {title && like && type && (
            <LikeButton entityId={entityId} type={type} lessonId={lessonId} moduleId={moduleId} />
          )}
        </div>
        <div>
          {title && favorite && category && (
            <BookmarkButton
              relationId={entityId || ''}
              metadata={entity!}
              category={category}
              typeId={resourceTypeId}
            />
          )}
        </div>
      </div>
    </div>
  );
}
